// AlignLeftIcon.tsx

import React from "react";

export const TextAlignLeftIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 12 12" fill="none" {...props}>
      <path
        d="M0 12V10.6667H12V12H0ZM0 9.3333V8H8V9.3333H0ZM0 6.6667V5.3333H12V6.6667H0ZM0 4V2.6667H8V4H0ZM0 1.3333V0H12V1.3333H0Z"
        fill="currentColor"
      />
    </svg>
  );
};
